"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "runCallback", {
    enumerable: true,
    get: function() {
        return runCallback;
    }
});
var runCallback = function(callback) {
    if (callback && typeof callback === "function") {
        callback();
    }
};

//# sourceMappingURL=runCallback.js.map